import { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { TextField, InputAdornment } from '@mui/material';
import { Close, Search } from '@mui/icons-material';

interface ISearchField {
  searchValue: string;
  handleSearch: (val: string) => void;
  isDisabled?: boolean;
  setSearchValue: (val: string) => void;
  handleSearchIcon?: (val?: boolean) => void;
  handleClearSearch?: () => void;
  placeholder?: string;
}

export const SearchField: FC<ISearchField> = ({
  placeholder,
  searchValue,
  handleSearch,
  isDisabled,
  setSearchValue,
  handleSearchIcon,
  handleClearSearch
}) => {
  const classes = useStyles();
  return (
    <TextField
      size="small"
      fullWidth
      variant="outlined"
      placeholder={placeholder ?? 'Search...'}
      name="search"
      value={searchValue}
      disabled={isDisabled}
      InputProps={{
        startAdornment: (
          <InputAdornment
            position="start"
            className={classes.searchIcon}
            onClick={() => {
              if (searchValue.length > 0) {
                if (handleSearchIcon) {
                  handleSearchIcon(true);
                }
                handleSearch(searchValue);
              }
            }}
          >
            <Search />
          </InputAdornment>
        ),
        endAdornment: searchValue ? (
          <InputAdornment
            position="end"
            className={classes.searchIcon}
            onClick={() => {
              if (handleClearSearch) {
                handleClearSearch();
              } else {
                setSearchValue('');
                handleSearch('');
              }
            }}
          >
            <Close />
          </InputAdornment>
        ) : null
      }}
      onKeyDown={e => {
        if (e.key === 'Enter' && searchValue.length > 0) {
          handleSearch(searchValue);
        }
      }}
      onChange={e => {
        setSearchValue(e.target.value);
      }}
    />
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  searchIcon: {
    cursor: 'pointer',
    color: theme.palette.grey[500]
  }
}));
